var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.obra)?_c(_setup.HeaderCustom,{attrs:{"title":"Gestão do Conhecimento"}},[_c('v-row',{staticClass:"ma-0 align-end justify-space-between mb-2"},[_c('v-col',{staticClass:"pb-0 ps-0",attrs:{"cols":"6"}},[_c('v-card-title',{staticClass:"px-0 pb-0"},[_c('v-btn',{attrs:{"icon":"","disabled":!_setup.canGoBack},on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',[_vm._v(" "+_vm._s(_setup.mdiArrowLeft)+" ")])],1),_vm._v(" "+_vm._s(_setup.obraDetails.title)+" ")],1)],1),_c(_setup.SeletorOpcoesImpressao,{attrs:{"items":[
        {
          text: 'Simplificado',
          value: 'S',
          icone: _setup.IconPaginaSimplificada,
        },
        {
          text: 'Detalhado',
          value: 'D',
          icone: _setup.IconPaginaDetalhada,
        },
      ]},on:{"change":_setup.store.download}})],1),[_c('sds-card',{attrs:{"title":"Informações Gerais"}},[_c(_setup.obraDetails.component,{tag:"component"})],1)]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }